import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { CX_INPUT_TIME_CONTROL_BUTTONS_TOKEN } from 'app/shared/cx-ui/cx-input-time/cx-input-time.config';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const cxTimeControlButtonsProvider = {
  provide: CX_INPUT_TIME_CONTROL_BUTTONS_TOKEN,
  deps: [FeatureToggleService],
  useFactory: (featureToggle: FeatureToggleService) => {
    return of(false).pipe(
      switchMap((controlButtons) => {
        controlButtons = featureToggle.isFeatureEnabled(Features.DATE_AND_TIME_CTRL_BTNS_UI);
        return of(controlButtons);
      }),
    );
  },
};
